export const FORM_KEYS = {
  TABLE_WRAPPER: {
    key: 'guidingPrincipleList',
  },
  TITLE: {
    label: 'Title',
    key: 'title',
    placeholder: 'Please enter the title here',
  },
  SUMMARY: {
    label: 'Summary',
    key: 'summary',
    placeholder: 'Please enter the summary here',
  },
  DES: {
    label: 'Description',
    key: 'guidingPrinciple',
    placeholder: 'Please enter the description here',
  },
  DELETE: {
    key: 'id',
  },

  DRAG: {
    key: 'drag',
  },
};
